import React, { Component } from "react";
import styled from "styled-components";
import nota from "../Global/nota.guidelines.json";
import NanoFlex from "../Global/NanoFlex.js";

import TableSearchListLine from "../Micro/TableSearchListLine.js";

const StyledTableSearchList = styled(NanoFlex)`
  width: 100%;
`;

const StyledBlank = styled.div`
  width: 100%;
  height: ${(props) => props.height + "px"};
`;

class TableSearchList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isVisible: true,
      isAllSelected: this.props.isAllSelected ? this.props.isAllSelected : false,
    };
    this.container = React.createRef();

    this.containerHeight = 0;
  }

  componentDidMount() {
    const lazyLoad = (target) => {
      const io = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting !== this.state.isVisible) {
              if (!entry.isIntersecting) {
                this.containerHeight = entry.boundingClientRect.height;
              }
              this.setState({ isVisible: entry.isIntersecting });
            }
          });
        },
        { rootMargin: "250px" }
      );

      io.observe(target);
    };

    if (this.container && this.container.current) {
      lazyLoad(this.container.current);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.isAllSelected !== prevProps.isAllSelected) {
      this.setState({ isAllSelected: this.props.isAllSelected ? this.props.isAllSelected : false });
    }
  }

  componentWillUnmount() {}

  isSelected = (item) => {
    let selected = this.props.selectedIds.includes(item.idProgram);
    switch (this.props.selectMode) {
      case "Exclude":
        return !selected;
      case "Include":
        return selected;
    }
    return false;
  };

  render() {
    if (!this.props.data) return null;

    return (
      <div ref={this.container}>
        {this.state.isVisible && (
          <StyledTableSearchList flexDirection={"column"}>
            {this.props.data.map((item) => {
              return <TableSearchListLine hideRatings={this.props.hideRatings} key={item.idProgram} data={item} isSelected={this.isSelected(item)} onSelectedChange={this.props.onSelectedChange} advancedSearchVisible={this.props.advancedSearchVisible} />;
            })}
          </StyledTableSearchList>
        )}
        {!this.state.isVisible && <StyledBlank height={this.containerHeight} />}
      </div>
    );
  }
}

export default TableSearchList;

// --- // Documentation // --- //
/*
import TableSearchList from './../Macro/TableSearchList.js';

<TableSearchList />
*/
